import GenericScheduleForm from './GenericScheduleForm'

export default GenericScheduleForm
